import type { AutocompleteData } from "@color-finder/color-finder-api/models";
import {
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  Stack,
  Typography,
} from "@mui/material";
import type { Dispatch } from "react";

export interface UseCaseOption {
  value: string;
  label: string;
}

export interface ColorSystemSelectProps {
  onChange: (value: string) => void;
  value: string;
  options: Array<UseCaseOption>;
  t: (key: string) => string;
  onIndustryChange?: Dispatch<Array<AutocompleteData>>;
}

export const UseCaseSelect = ({
  onChange,
  value,
  options,
  t,
  onIndustryChange,
}: ColorSystemSelectProps) => {
  return (
    <FormControl
      fullWidth
      sx={{
        ".MuiInputBase-root.MuiOutlinedInput-root.MuiInputBase-colorPrimary.MuiInputBase-formControl":
          { borderRadius: "4px" },
      }}
    >
      <InputLabel>{t("filter_use_case_name")}</InputLabel>
      <Select
        value={value}
        onChange={(e) => {
          onChange(e.target.value);
          onIndustryChange?.([...[]]);
        }}
        label={t("filter_use_case_name")}
      >
        {options.map((option) => (
          <MenuItem key={option.value} value={option.value}>
            <Stack
              width="100%"
              direction="row"
              alignItems="center"
              justifyContent="space-between"
            >
              <Typography>{t(option.label)}</Typography>
            </Stack>
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
};
